import { ForwardedRef, forwardRef, ReactNode } from 'react'
import { twMerge } from 'tailwind-merge'
import { Icon } from '../Icon/Icon'
import { faCheck, faMinus } from '../../icons/solid'
import { Merge } from '../../util/types'

interface CoreCheckboxProps {
  children?: ReactNode
  status: 'checked' | 'unchecked' | 'mixed'
  className?: string | undefined
}

type CheckboxProps = Merge<React.ComponentProps<'input'>, CoreCheckboxProps>

export const Checkbox = forwardRef(
  function Checkbox ({ children, status = 'checked', onChange, disabled = false, className, ...props }: CheckboxProps, ref: ForwardedRef<HTMLInputElement>) {
    return (
      <label
        className={twMerge(
          'core-checkbox',
          'typo-body flex cursor-pointer items-center gap-2',
          disabled && 'cursor-not-allowed text-gray-400',
          className
        )}
      >

        <input
          ref={ref}
          type='checkbox'
          onChange={onChange}
          disabled={disabled}
          checked={status !== 'unchecked'}
          hidden
          {...props}
        />

        <div
          className={twMerge(
            'core-checkbox', 'flex h-4 w-4 items-center justify-center rounded-[2px] border-2',
            status !== 'unchecked'
              ? 'border-black bg-black text-white'
              : 'border-gray-200 bg-white',
            disabled && 'opacity-40'
          )}
        >
          {status !== 'unchecked' && (
            <Icon
              className='!h-3 !w-3'
              icon={status === 'mixed' ? faMinus : faCheck}
            />
          )}
        </div>

        {children}

      </label>
    )
  }
)
